<script>
  import Footer from "../Components/Footer.svelte";
  import Title from "../Components/Title.svelte";
  import { useFocus } from "svelte-navigator";
  const focus = useFocus();

</script>

<svelte:head>
  <meta name="description"
  content="Discover Country Cruel merchandise. Visit the online store.">
  <title>Merch - Country Cruel</title>
</svelte:head>
<h2 use:focus>Merch</h2>
<main>
  <p>No merchandise yet! Please check back later.</p>
  <Title />

</main>
<Footer />